module.exports = __webpack_public_path__ + "a56b12f1f5b8dc5d8ce505fd81edae5f.jpg";